export interface Icampaignschedule {
  id: number;
  countryC: string;
  divisionK: number;
  campaignN: string;
  campaignS: boolean;
  initCampaignS: Date;
  endCampaignS: Date;
  participantTypeC: string;
  discountTypeC: string;
  discountValueA: number;
  accumulativeDiscountC: string;
  complimentaryC: boolean;
  modalDescriptionC: boolean;
  isRoundPercentualValue: boolean;
  applyMaintenance1F: boolean;
  applyMaintenance2F: boolean;
  applyMaintenance3F: boolean;
  applyMaintenance4F: boolean;
  applyMaintenance5F: boolean;
  applyMaintenance6F: boolean;
  maintenance1RequiredF: boolean;
  maintenance2RequiredF: boolean;
  maintenance3RequiredF: boolean;
  maintenance4RequiredF: boolean;
  maintenance5RequiredF: boolean;
  planTypeC?: string;
  scheduleOriginDealer?: boolean;
  scheduleOriginFordpass?: boolean;
  scheduleOriginWeb?: boolean;
  scheduleOriginMobile?: boolean;
  campaignShortDescriptionN?: string;
  campaignLongDescriptionN?: string;
  campaignShortDescription?: string;
  campaignLongDescription?: string;
  createUserC: string;
  createS: Date;
  lastUpdtUserC?: string;
  lastUpdtS?: number;
  isValid?: boolean;
  isExpired?: boolean;
}
